<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="less">
@import './assets/style/index.scss';
* {
  margin: 0px;
  padding: 0px;
  user-select: none;
}

.c-min-img {
  min-width: 6px;
  min-height: 6px;
}

.flex_column_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex_row_center {
  display: flex;
  flex-direction: row;
  align-items: center;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body{
 &::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
      display: none;
  height: 1px;
} 
}
::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #004b85;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
</style>
